import React from "react";
import {cx} from "../lib/ClassSet";
import ThreeDots from "./shared/icons/ThreeDots";
import styles from "./ContextMenuTrigger.module.scss";

const ContextMenuTrigger = (props) => {

  let classes = cx({
    [styles.module]: true,
    [styles.uActive]: props.active,
    [styles.uInactive]: !props.active
  })
  let clickFn = null;
  if (props.active) {
    clickFn = (e) => {
      e.preventDefault();
      e.stopPropagation();
      let rect = e.target.getBoundingClientRect();
      props.onClick(Math.round(e.clientX + rect.width/2), Math.round(e.clientY, rect.height/2));
    }
  }
  return (
    <div className={classes} onClick={clickFn}>
      <ThreeDots />
    </div>
  );
}

ContextMenuTrigger.defaultProps = {
  active: true
}

export default ContextMenuTrigger;